import { useTranslation } from "react-i18next";

import { Link, Arrange } from "@aviary";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";
import { getParamsString } from "@shared/hooks/useUrlParams/useUrlParams";

import { SidebarMenu } from "../SidebarMenu/SidebarMenu";

interface Props {
  onClose: () => void;
}

const Quality = ({ onClose }: Props) => {
  const { t } = useTranslation();

  const getEQPPath = () => {
    const eqpParams = getParamsString({
      eqpLevels: ["Gold", "Silver"],
    });

    return `${emersonRoutes.shop.catalog}?${eqpParams}`;
  };

  return (
    <SidebarMenu title={t(l.header.Quality.Header)}>
      <Arrange isVertical isFullWidth>
        <Link
          href={emersonRoutes.external.quality.about}
          isColor="system"
          isUnderLined={false}
          isHoverUnderLined={false}
          noExternalIcon
        >
          {t(l.header.Quality.About)}
        </Link>
        <Link
          to={getEQPPath()}
          isColor="system"
          isUnderLined={false}
          isHoverUnderLined={false}
          onClick={onClose}
        >
          {t(l.header.Quality.QualityPartners)}
        </Link>
      </Arrange>
    </SidebarMenu>
  );
};

export { Quality };
